/* eslint-disable @typescript-eslint/ban-ts-comment */
import useSWR from 'swr'
import fetcher from '../fetcher'
import convertMinutesToMilliseconds from '../convertMinutesToMilliseconds'
import { WebcastListItemProps } from '../../components/WebcastListItem'
import { ChannelFeedResponse, defaultState } from '../fetchChannelFeed'
import useGigIDs from '../useGigIDs'

function hasRequiredProps (channelId: string | string[], webcastId: string | string []) {

  return typeof channelId === 'string' &&
    channelId !== '' &&
    typeof webcastId === 'string' &&
    webcastId !== ''

}

const useChannelFeed = (initialData: ChannelFeedResponse = defaultState, hostUrl = '') => {

  const { channelId, webcastId } = useGigIDs()

  const swrKey = hasRequiredProps(channelId, webcastId)
    ? [ 'channelFeed', hostUrl, '', channelId, webcastId ]
    : null

  // @ts-ignore
  const swr = useSWR<WebcastListItemProps[], any>(swrKey, {
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {

      if (error.status === 404) return

      // Retry every five minutes on failure
      setTimeout(() => revalidate({ retryCount: retryCount + 1 }), convertMinutesToMilliseconds(5))

    },
    initialData,
    revalidateOnMount: false,
    revalidateOnFocus: false,
    fetcher
  })

  return swr

}

export default useChannelFeed
